import React, { useState } from 'react';
import { makingOffVideos, v2YearsBadge } from '../../pages/SiteRefreshPreview/siteRefreshContent';
import PreviewCaseModal from './PreviewCaseModal';

const PreviewAbout = ({ stats }) => {
  const [makingOffIndex, setMakingOffIndex] = useState(0);
  const [activeVideo, setActiveVideo] = useState(null);

  const currentMakingOff = makingOffVideos[makingOffIndex] ?? makingOffVideos[0];
  const dots = makingOffVideos.length;

  const openMakingOff = () => {
    if (!currentMakingOff) return;
    setActiveVideo({
      title: currentMakingOff.title,
      category: 'Bastidores',
      description: currentMakingOff.description,
      longDescription: currentMakingOff.description,
      video: currentMakingOff.video,
    });
  };

  const closeMakingOff = () => setActiveVideo(null);

  return (
    <section className="site-refresh__section site-refresh__section--about">
      <div className="site-refresh__shell site-refresh__about-grid">
        <article className="site-refresh__about-card" id="bastidores">
          <div className="site-refresh__eyebrow">Bastidores</div>
          <div className="site-refresh__video-card">
            {currentMakingOff ? (
              <video
                className="site-refresh__video-thumb"
                src={currentMakingOff.video}
                muted
                loop
                playsInline
              />
            ) : null}
            <div className="site-refresh__video-overlay" />
            <button
              type="button"
              className="site-refresh__play-button"
              aria-label="Abrir bastidores"
              onClick={openMakingOff}
            >
              ▶
            </button>
          </div>
          {dots > 1 ? (
            <div className="site-refresh__dots" aria-label="Selecionar vídeo" role="tablist">
              {makingOffVideos.map((item, index) => (
                <button
                  key={item.title}
                  type="button"
                  className={`site-refresh__dot ${index === makingOffIndex ? 'site-refresh__dot--active' : ''}`}
                  onClick={() => setMakingOffIndex(index)}
                  aria-label={`Selecionar bastidores: ${item.title}`}
                />
              ))}
            </div>
          ) : null}
        </article>

      <article className="site-refresh__about-card" id="sobre">
        <div className="site-refresh__eyebrow">Sobre a Napalm</div>
        <div className="site-refresh__years-badge">
          <img
            className="site-refresh__years-image"
            src={v2YearsBadge}
            alt="18 years on fire"
          />
        </div>
        <p className="site-refresh__intro">
          Há mais de uma década unimos arte, tecnologia e storytelling para criar jogos,
          animações, VR e experiências visuais para marcas que buscam impacto real.
        </p>
        <a href="/Cases" className="site-refresh__button site-refresh__button--outline" style={{display: 'none'}}>
          Conheça nossa história
          <span className="site-refresh__arrow" aria-hidden="true">
            →
          </span>
        </a>
      </article>

      <article className="site-refresh__about-card">
        <div className="site-refresh__eyebrow">Nossa essência</div>
        <h3 className="site-refresh__essence-title">Arte + Tecnologia + Impacto</h3>
        <div className="site-refresh__stats-list">
          {stats.map((item) => (
            <div key={item.value} className="site-refresh__stat-row">
              <div className="site-refresh__stat-value">{item.value}</div>
              <div className="site-refresh__stat-label">{item.label}</div>
            </div>
          ))}
        </div>
      </article>
      </div>

      <PreviewCaseModal caseItem={activeVideo} onClose={closeMakingOff} />
    </section>
  );
};

export default PreviewAbout;
